import { arrayToChunks } from "./array-to-chunks";

export const objectToChunks = (obj: any, chunkSize: number = 2) => {
  const objArray = arrayToChunks(Object.entries(obj), chunkSize);
  const objChunks: any[] = [];
  objArray.forEach(chunk => {
    const objChunk: any = {};
    chunk.forEach(([key, value]) => {
      objChunk[key] = value;
    })
    objChunks.push(objChunk);
  });
  return objChunks;
};
